/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationListRequestSortCriteria {
    getFixupPrototypeFunction() { return PromptRecommendationListRequestSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationListRequestSortCriteria>): PromptRecommendationListRequestSortCriteria {
        let obj = Object.assign(new PromptRecommendationListRequestSortCriteria(), model);
        PromptRecommendationListRequestSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationListRequestSortCriteria>): PromptRecommendationListRequestSortCriteria {
        if (!model) return null;
        return PromptRecommendationListRequestSortCriteria.newInstance(<PromptRecommendationListRequestSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationListRequestSortCriteria) {
        if (!obj) return;

        models.PromptRecommendationListRequestSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationListRequestSortCriteria): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationListRequestSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.PromptRecommendationListRequestSortColumn;

    ascending: boolean;

}
